import { render, staticRenderFns } from "./TaskContainer.vue?vue&type=template&id=4d9c2349&"
import script from "./TaskContainer.vue?vue&type=script&lang=js&"
export * from "./TaskContainer.vue?vue&type=script&lang=js&"
import style0 from "./TaskContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports